import { Component, Host, h, Prop } from '@stencil/core';
import state from './../../../state/cta-price';


@Component({
  tag: 'afs-buy-warning',
  styleUrl: 'afs-buy-warning.sass',
  shadow: true,
})
export class AfsBuyWarning {

  warningWrapper : HTMLElement;

  @Prop() numbersExceededWarning : string = "Purchase is limited to ___";
  @Prop() quantityExceededWarning : string = "Purchase is limited to a quantity of ___ for this price point"
  @Prop() stringKey : string = "___";

  animateHeight(el: HTMLElement = this.warningWrapper) {
    const contentHeight = getComputedStyle(el.children[0]).getPropertyValue('height');
    el.style.height = parseInt(contentHeight) + 'px';
  }

  componentDidRender(){
    this.animateHeight();
  }

  render() {

    const errorList = [
        {
            errorTopic: 'numbersExceeded',
            value: state.CTANumbersExceeded,
            valueIsNull: state.CTANumbersExceeded === null,
            message: this.numbersExceededWarning.replace(this.stringKey, `${state.CTANumbersLimit} ${state.CTATotalEntriesLang.toLowerCase()}`),
        },
        {
            errorTopic: 'quantityExceeded',
            value: state.CTAQuantityExceeded,
            valueIsNull: state.CTAQuantityExceeded === null,
            message: this.quantityExceededWarning.replace(this.stringKey, state.CTAQuantityExceeded),
        }
    ];
    
    return (
      <Host>
        <div class="wrapper" ref={ el => this.warningWrapper = el }>
          <div>
            {
              errorList.map(error => (
                <div class="content-wrapper" style={{ display: error.valueIsNull ? 'none' : 'block' }}>
                  <div class="content">{ error.message }</div>
                </div>
              ))
            }
          </div>
        </div>
      </Host>
    );
  }

}
